import React from "react"
import Page from "../../../layout/web/Page";
import {Col, Form, Row} from "antd";
import { Input, Select, InputNumber, DatePicker, AutoComplete, Cascader,Button } from 'antd';
import SelectBar2 from "../../../components/web/workboard/SelectBar2";
import moment from "moment";
import Connector from "../../../redux/connector";
import {PostToPbx, PostToPbx2} from "../../../api/http-post";
import TableDataView from "../../../components/Common/tables/TableDataView";

const { Option } = Select;
const currentDate = moment().format("YYYY-MM-DD")
class WorkboardInboundCallStatePage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: currentDate,
            endDate: currentDate,
            lineNumber: "27111000243",
            state: "ABANDON",
            reports: [],
            isLoading:false,
        }
    }

    handleInput = (key, val) => {
        console.log("handleInput > ",key,val)
        this.setState({
            [key]:val
        })
    }

    submitSearch=async ()=>{
        let _this=this;
        let hub = {
            StartDate: this.state.startDate,
            EndDate: this.state.endDate,
            State: this.state.state,
            LineNumber:this.state.lineNumber
        }
        _this.setState({
            isLoading: true,
            reports: [],
        })
        let endpoint = "/desk/calls/abandon";
        await PostToPbx(hub, endpoint, async (dataIn) => {
            let  data = dataIn.RESULT;
            if(data===null){
                data=[];
            }
            console.log(endpoint + " submitSearch ---> ", endpoint, " > ", hub, data);
            _this.setState({
                reports: data,
                isLoading: false
            })
        });
    }
    PostState = async (hub, endpoint, stateKey) => {
        let _this = this;
        this.setState({
            isLoading: true
        })
        await PostToPbx2(hub, endpoint, async (dataIn) => {
            const data = dataIn.RESULT;
            console.log(endpoint + " response ---> ", endpoint, " > ", hub, data);
            _this.setState({
                [stateKey]: data,
                isLoading: false
            })
        });
    }

    renderList = () => {

        if(this.state.isLoading){
            return(
                <p style={{textAlign:"center",color:"red",fontWeight:"bold",fontSize:24}}>
                    Busy searching your request , please wait .....
                </p>
            )
        }

        let columns = [
            {id: "Customer", label: "Customer", dataType: "string"},
            {id: "OrgDateTime", label: "Date & Time", dataType: "string"},
            {id: "QueuePeriodText", label: "Duration", dataType: "string"},
            {id: "LineNumber", label: "Line Number", dataType: "string"},
        ];

        let data= this.state.reports;

        if(data===null){
            data=[];
        }

        let store =  {columns: columns, data: data}
        return(
            <TableDataView
                {...store}
                tableTitle={"Data range: "+ " Records  (" + data.length + ") "}
                otherFunctions={[]}
                options={{
                    pageSize:20,
                }}
                noAddButton={true}
            />
        )
    }


    render() {
        return (
            <Page {...this.props}>
                <div style={{
                    minHeight: "100%",
                    overflow: "auto",
                    marginBottom: 20
                }}>
                    <Form layout="vertical" hideRequiredMark>

                        <Row gutter={16}>
                            <Col span={24}>
                                <SelectBar2 _this={this} {...this.props} />
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Input.Group compact>
                                    <Select
                                        style={{ width: '30%' }}
                                        defaultValue="ABANDON"
                                        onChange={(e)=>this.handleInput("state",e)}
                                    >
                                        <Option value="ABANDON">ABANDON CALL</Option>
                                        <Option value="COMPLETED">COMPLETED CALL</Option>
                                    </Select>
                                    <Input
                                        style={{ width: '30%' }}
                                        onChange={(e)=>this.handleInput("lineNumber",e.target.value)}
                                        value={this.state.lineNumber}
                                        placeholder={"Line Number e.g 277213904"}
                                        />
                                        <Button
                                            style={{ width: '32%' }}
                                            onClick={()=>this.submitSearch()}
                                        >
                                            Search
                                        </Button>
                                </Input.Group>
                            </Col>
                        </Row>

                    </Form>

                    <Row gutter={16} style={{marginTop:10}}>
                        <Col span={24}>
                            <hr/>
                        </Col>
                    </Row>

                    <Row gutter={16} style={{marginTop:50}}>
                        <Col span={24}>
                            {this.renderList()}
                        </Col>
                    </Row>

                </div>
            </Page>
        )
    }
}

export default Connector(WorkboardInboundCallStatePage);
